import { render, staticRenderFns } from "./StudentMarkReviewPage.vue?vue&type=template&id=584c52df&scoped=true&"
import script from "./StudentMarkReviewPage.vue?vue&type=script&lang=js&"
export * from "./StudentMarkReviewPage.vue?vue&type=script&lang=js&"
import style0 from "./StudentMarkReviewPage.vue?vue&type=style&index=0&id=584c52df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584c52df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VIcon,VSpacer})
